import { trpc } from '@/shared/api/trpc';

export const useUndoOperationLog = () => {
  const utils = trpc.useUtils();
  return trpc.operationLog.undo.useMutation({
    onSettled: () => {
      utils.operationLog.findByItinerary.invalidate();
      utils.operationLog.findRecent.invalidate();
      utils.operations.list.invalidate();
      utils.operations.filterCounts.invalidate();
      utils.operations.countMany.invalidate();
      utils.operations.flaggedCounts.invalidate();
      utils.operations.failedMessageCount.invalidate();
      // Reversing a log row mutates the itinerary/item; refresh what the
      // detail (planner) and list pages render so the change shows without
      // a manual reload. Items are bundled into itineraries.byId.
      utils.itineraries.byId.invalidate();
      utils.itineraries.search.invalidate();
    },
  });
};
